/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { Menu } from "@headlessui/react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/userSlice";
import { useTranslation } from "react-i18next";
import { Dropdown } from "../index";
import {
  AddCouponIcon,
  AvatarIcon,
  LogoutIcon,
  MyBillingIcon,
  MyPdfIcon,
  UpgradeIcon,
} from "../icons/SVGs";

const ProfileDropdown = ({ profile }) => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const html = document.getElementsByTagName("html")[0].dir;

  return (
    <>
      <Dropdown
        menuClass="w-44 py-2"
        direction={html === "rtl" ? "left" : "right"}
        iconClass={"2xl:w-12 2xl:h-12 w-10 h-10 text-secondary-80"}
        icon={
          <Menu.Button className="w-full h-full">
            {!profile.profileImage ? (
              <AvatarIcon className="w-full h-full" />
            ) : (
              <figure className="relative w-full h-full">
                <img
                  unoptimized={true}
                  fill={true}
                  alt="profile picture"
                  src={profile.profileImage}
                  className="inline-flex object-cover justify-center w-full h-full rounded-full"
                />
              </figure>
            )}
          </Menu.Button>
        }
        options={[
          {
            icon: <AvatarIcon className="w-4.5 h-4.5" />,
            value: t("Profile"),
            className: "font-normal",
            action: () => {
              window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/profile`;
            },
          },
          {
            icon: <MyPdfIcon className="w-4.5 h-4.5" />,
            value: t("My PDF"),
            className: "font-normal",
            action: () => {
              window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/my-pdf`;
            },
          },
          {
            icon: <MyPdfIcon className="w-4.5 h-4.5" />,
            value: t("My AI Project"),
            className: "font-normal",
            action: () => {
              window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/my-project`;
            },
          },
          {
            icon: <AddCouponIcon className="w-4.5 h-4.5" />,
            value: t("Add Coupons"),
            className: "font-normal",
            action: () => {
              window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/coupon`;
            },
          },
          {
            icon: <MyBillingIcon className="w-4.5 h-4.5" />,
            value: t("My Billing"),
            className: "font-normal",
            action: () => {
              window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/my-billing`;
            },
          },
          {
            icon: <UpgradeIcon className="w-4.5 h-4.5" />,
            value: t("Upgrade Now"),
            className: "font-normal",
            action: () => {
              window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/subscription-plans`;
            },
          },
          {
            icon: <LogoutIcon className="w-4.5 h-4.5" />,
            value: t("Sign out"),
            className: "font-normal",
            onClick: async () => {
              Cookies.remove("session_id", {
                domain: process.env.REACT_APP_PUBLIC_DOMAIN,
                path: "/",
              });
              dispatch(logout());
            },
          },
        ]}
      />
    </>
  );
};
export default ProfileDropdown;
